"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HilProjectPreview = exports.HilRevisionStatus = void 0;
exports.hilRevisionStatusToBuildStatus = hilRevisionStatusToBuildStatus;
exports.buildStatusToHilRevisionStatus = buildStatusToHilRevisionStatus;
const cadstrom_shared_1 = require("@cadstrom/cadstrom-shared");
const z = __importStar(require("zod"));
var HilRevisionStatus;
(function (HilRevisionStatus) {
    HilRevisionStatus["Complete"] = "complete";
    HilRevisionStatus["Processing"] = "processing";
    HilRevisionStatus["Validating"] = "validating";
    HilRevisionStatus["BomAwaitingCustomerReview"] = "bom_awaiting_customer_review";
    HilRevisionStatus["ProcessingBom"] = "processing_bom";
    HilRevisionStatus["ReadyToAnalyze"] = "ready_to_analyze";
    HilRevisionStatus["ProcessingDesign"] = "processing_design";
    HilRevisionStatus["AnalysisComplete"] = "analysis_complete";
    HilRevisionStatus["Error"] = "error";
    HilRevisionStatus["TimedOut"] = "timed_out";
    HilRevisionStatus["CreditRequired"] = "credit_required";
})(HilRevisionStatus || (exports.HilRevisionStatus = HilRevisionStatus = {}));
function hilRevisionStatusToBuildStatus(status) {
    switch (status) {
        case HilRevisionStatus.Complete:
            return cadstrom_shared_1.BuildStatus.Complete;
        case HilRevisionStatus.Processing:
            return cadstrom_shared_1.BuildStatus.Processing;
        case HilRevisionStatus.Validating:
            return cadstrom_shared_1.BuildStatus.Validating;
        case HilRevisionStatus.BomAwaitingCustomerReview:
            return cadstrom_shared_1.BuildStatus.BomAwaitingReview;
        case HilRevisionStatus.ProcessingBom:
            return cadstrom_shared_1.BuildStatus.ProcessingBom;
        case HilRevisionStatus.ReadyToAnalyze:
            return cadstrom_shared_1.BuildStatus.ReadyToAnalyze;
        case HilRevisionStatus.ProcessingDesign:
            return cadstrom_shared_1.BuildStatus.ProcessingDesign;
        case HilRevisionStatus.AnalysisComplete:
            return cadstrom_shared_1.BuildStatus.AnalysisComplete;
        case HilRevisionStatus.Error:
            return cadstrom_shared_1.BuildStatus.Error;
        case HilRevisionStatus.TimedOut:
            return cadstrom_shared_1.BuildStatus.TimedOut;
        case HilRevisionStatus.CreditRequired:
            return cadstrom_shared_1.BuildStatus.CreditRequired;
    }
}
function buildStatusToHilRevisionStatus(status) {
    switch (status) {
        case cadstrom_shared_1.BuildStatus.Complete:
            return HilRevisionStatus.Complete;
        case cadstrom_shared_1.BuildStatus.Processing:
            return HilRevisionStatus.Processing;
        case cadstrom_shared_1.BuildStatus.Validating:
            return HilRevisionStatus.Validating;
        case cadstrom_shared_1.BuildStatus.Error:
            return HilRevisionStatus.Error;
        case cadstrom_shared_1.BuildStatus.TimedOut:
            return HilRevisionStatus.TimedOut;
        case cadstrom_shared_1.BuildStatus.CreditRequired:
            return HilRevisionStatus.CreditRequired;
        case cadstrom_shared_1.BuildStatus.BomAwaitingReview:
            return HilRevisionStatus.BomAwaitingCustomerReview;
        case cadstrom_shared_1.BuildStatus.ProcessingBom:
            return HilRevisionStatus.ProcessingBom;
        case cadstrom_shared_1.BuildStatus.ReadyToAnalyze:
            return HilRevisionStatus.ReadyToAnalyze;
        case cadstrom_shared_1.BuildStatus.ProcessingDesign:
            return HilRevisionStatus.ProcessingDesign;
        case cadstrom_shared_1.BuildStatus.AnalysisComplete:
            return HilRevisionStatus.AnalysisComplete;
        case cadstrom_shared_1.BuildStatus.Pending:
        case cadstrom_shared_1.BuildStatus.Abandoned:
        case cadstrom_shared_1.BuildStatus.Unknown:
            return HilRevisionStatus.Processing;
    }
}
const hilProjectPreviewSchema = z.object({
    id: z.string(),
    name: z.string(),
    ownerId: z.string().nullable(),
    latestRevision: z
        .object({
        id: z.string(),
        name: z.string(),
        status: z.nativeEnum(HilRevisionStatus),
        hasUploadedFiles: z.boolean(),
        automationMode: cadstrom_shared_1.buildAutomationModeSchema.optional(),
        erroredFromStatus: z.nativeEnum(HilRevisionStatus).optional(),
        updatedAt: z.number(),
    })
        .nullable(),
    totalRevisionCount: z.number(),
    isDemo: z.boolean(),
    demoSourceProjectId: z.string().nullable(),
    createdAt: z.number().nullable(),
    updatedAt: z.number().nullable(),
});
exports.HilProjectPreview = {
    create(input) {
        return hilProjectPreviewSchema.parse(input);
    },
    schema: hilProjectPreviewSchema,
};
//# sourceMappingURL=hil-project-preview.js.map